import { render } from "./contactView.vue?vue&type=template&id=21829902"
import script from "./contactView.vue?vue&type=script&lang=js"
export * from "./contactView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__